import { FilterDefinition } from './filter-definition'

export class FilterCollection extends Array<FilterDefinition> {
  public parameters: FilterDefinition[]
  public inPopup: boolean

  constructor(model: FilterCollection) {
    super()
    this.parameters = this.mapFilters(model.parameters)
    this.push(...this.parameters)
    this.inPopup = this.CalculateInPopup(model.parameters)
  }

  public allApplyOnChange(): boolean {
    return !this.parameters.some((p) => p.applyOnChange == false)
  }

  private mapFilters(filterDefs: FilterDefinition[]): FilterDefinition[] {
    const mappedFilters: FilterDefinition[] = []
    if (filterDefs) {
      filterDefs.forEach((f) => {
        mappedFilters.push(new FilterDefinition(f))
      })
    }

    return mappedFilters
  }

  private CalculateInPopup(filterDefs: FilterDefinition[]): boolean {
    if (filterDefs) {
      const visibleFilters = filterDefs.filter((i) => i.visible == true)
      return visibleFilters && visibleFilters.length > 3
    } else return false
  }
}
